import { useAuth, useUser } from "@clerk/clerk-react";
import BottomNavbar from "Components/BottomNavbar/BottomNavbar";
import Transitions from "Components/Transitions/Transitions";
import { AnimatePresence } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import camera from "../../Assets/Images/camera.svg";
import defaultProfile from "../../Assets/Images/default.webp";
import {
  createIdentity,
  editUser,
  getIdentity,
  getUser,
} from "../../Redux/Profile/ProfileActions";
import AccountInfo from "./ProfileComponents/AccountInfo/AccountInfo";
import Identity from "./ProfileComponents/Identity/Identity";
import PersonalInfo from "./ProfileComponents/PersonalInfo/PersonalInfo";
import Security from "./ProfileComponents/Security/Security";
import Wallet from "./ProfileComponents/Wallet/Wallet";
import { toast } from "sonner";
import { Skeleton } from "Components/ui/skeleton";
import UseInnerWidth from "hooks/UseInnerWidth";
import { Button } from "Components/ui/button";
import { Separator } from "Components/ui/separator";
import DropDown from "Components/DropDown/DropDown";
import DropdownInput from "Components/DropDownInput/DropDownInput";

function Profile() {
  const [personalInfoData, setPersonalInfoData] = useState({});
  const [accountInfoData, setAccountInfoData] = useState({});
  const [securityData, setSecurityData] = useState({});
  const [identityData, setIdentityData] = useState({});

  const [found, setFound] = useState(false);
  const clerkUser = useUser().user;
  const tabs = [
    {
      title: "Personal Information",
      component: (
        <PersonalInfo data={personalInfoData} setData={setPersonalInfoData} />
      ),
    },
    {
      title: "Account Information",
      component: (
        <AccountInfo data={accountInfoData} setData={setAccountInfoData} />
      ),
    },
    {
      title: "Security",
      component: <Security data={securityData} setData={setSecurityData} />,
    },
    {
      title: "Identity",
      component: <Identity data={identityData} setData={setIdentityData} />,
    },
  ];

  const [SelectedTab, setSelectedTab] = useState(0);

  const [image, setImage] = useState("");

  const imageRef = useRef();

  const {
    user,
    identity,
    editUserSuccess,
    editIdentitySuccess,
    getUserError,
    getIdentityError,
    editUserError,
    editIdentityError,
    getWalletInfoError,
    getTransactionsError,
    getLiveChallengesError,
    getUserLoading,
    getIdentityLoading,
    getWalletInfoLoading,
    getTransactionsLoading,
  } = useSelector((state) => state.ProfileReducer);

  useEffect(() => {
    if (editUserSuccess || editIdentitySuccess) {
      toast.success("Profile Updated Successfully", {
        autoClose: 2000,
        className: "bg-green-opacity text-green",
      });
    }
  }, [editUserSuccess, editIdentitySuccess]);

  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  useEffect(() => {
    tab && setSelectedTab(Number(tab));
  }, [tab]);

  useEffect(() => {
    if (
      getUserError ||
      getIdentityError ||
      editUserError ||
      editIdentityError ||
      getWalletInfoError ||
      getTransactionsError ||
      getLiveChallengesError
    ) {
      toast.error(
        getUserError ||
          getIdentityError ||
          editUserError ||
          editIdentityError ||
          getWalletInfoError ||
          getTransactionsError ||
          getLiveChallengesError,
        {
          autoClose: 2000,
          className: "bg-red-opacity text-red",
        }
      );
    }
  }, [
    getUserError,
    getIdentityError,
    editUserError,
    editIdentityError,
    getWalletInfoError,
    getTransactionsError,
    getLiveChallengesError,
  ]);

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { getToken } = useAuth();

  useEffect(() => {
    !user && dispatch(getUser(getToken));
    dispatch(getIdentity(getToken));
  }, []);

  useEffect(() => {
    navigate(`/profile?tab=${SelectedTab}`);
  }, [SelectedTab]);

  useEffect(() => {
    if (SelectedTab === 0) {
      if (
        personalInfoData?.firstName !== user?.firstName ||
        personalInfoData?.lastName !== user?.lastName ||
        personalInfoData?.title !== user?.title ||
        personalInfoData?.phone !== user?.phone ||
        personalInfoData?.email !== user?.email ||
        personalInfoData?.country !== user?.country ||
        personalInfoData?.city !== user?.city ||
        personalInfoData?.street !== user?.street ||
        personalInfoData?.postalCode !== user?.postalCodeCode
      ) {
        setFound(true);
      } else {
        setFound(false);
      }
    } else if (SelectedTab === 1) {
      if (
        accountInfoData?.nickName !== user?.nickName ||
        accountInfoData?.timezone !== Number(user?.timezone) ||
        accountInfoData?.language !== user?.language
      ) {
        setFound(true);
      } else {
        setFound(false);
      }
    } else if (SelectedTab === 2) {
      if (
        !(
          !securityData.pass ||
          !securityData.new_pass ||
          !securityData.confirm_new_pass ||
          securityData.new_pass !== securityData.confirm_new_pass
        )
      ) {
        setFound(true);
      } else {
        setFound(false);
      }
    } else if (SelectedTab === 3) {
      setFound(false);
    }
  }, [
    identityData,
    accountInfoData,
    securityData,
    personalInfoData,
    user,
    identity,
    SelectedTab,
  ]);

  const width = UseInnerWidth();

  return (
    <div className="relative">
      {tabs[SelectedTab]?.title !== "Wallet" && (
        <>
          <input
            type="file"
            onChange={(e) => {
              dispatch(editUser({ image: e.target.files[0] }, getToken));
            }}
            className="hidden"
            ref={imageRef}
          />
          {getUserLoading ? (
            <div className=" rounded-lg p-8 pt-0 flex items-center space-x-4">
              <Skeleton
                className={`${
                  width < 1024 ? "w-[75px] h-[75px]" : "w-[100px] h-[100px]"
                } rounded-full aspect-square`}
              />
              <div className="space-y-2">
                <Skeleton className="h-4 w-[250px]" />
                <Skeleton className="h-4 w-[200px]" />
              </div>
            </div>
          ) : (
            <div className="rounded-lg p-8 pt-0 flex flex-row items-center gap-4">
              <div
                className={`${
                  width < 1024 ? "w-[75px] h-[75px]" : "w-[100px] h-[100px]"
                } aspect-square  rounded-full relative cursor-pointer`}
                onClick={() => {
                  imageRef.current.click();
                }}
              >
                <img
                  src={
                    (image && URL.createObjectURL(image)) ||
                    user?.profile ||
                    defaultProfile
                  }
                  alt="user_img"
                  className="w-full h-full object-cover rounded-full aspect-square"
                />
                <img
                  src={camera}
                  alt="camera"
                  className={`${
                    width < 1024 ? "right-0" : "right-4"
                  } absolute bottom-0 `}
                />
              </div>
              <div className="flex flex-col items-start sm:flex-row sm:items-center gap-2 sm:gap-4">
                <div>
                  <div
                    className={`${
                      width < 1024 ? "text-[20px]" : "text-[28px]"
                    } font-N_Medium`}
                  >{`${user?.firstName || "-"} ${user?.lastName || "-"}`}</div>
                  <div
                    className={`${
                      width < 1024 ? "text-base" : "text-base -mt-2"
                    } font-N_Roman  opacity-30`}
                  >
                    {user?.email}
                  </div>
                </div>
                {user?.isVerified ? (
                  <div className="bg-green-opacity text-green text-base rounded-full px-4 py-1">
                    Verified
                  </div>
                ) : (
                  <div className="bg-red-opacity text-red rounded-full text-base px-4 py-1">
                    Not Verified
                  </div>
                )}
              </div>
            </div>
          )}
          {}
        </>
      )}
      <div className="w-full overflow-x-scroll sm:hidden">
        <div className="flex flex-row items-center min-w-full flex-nowrap">
          {tabs?.map((tab, index) => (
            <div
              key={index}
              className={`shrink-0 ${
                SelectedTab === index
                  ? "bg-background-secondaryOpacity rounded-full text-primary"
                  : "text-white-opacity"
              } cursor-pointer text-base mb-4 py-2 px-4`}
              onClick={() => setSelectedTab(index)}
            >
              {tab.title}
            </div>
          ))}
        </div>
      </div>

      <div>
        <div
          className={
            "border-none sm:border-2 border-border-darkNew rounded-lg bg-background flex sm:flex-row flex-col gap-2 w-full "
          }
        >
          <div className="m-6 w-[18rem] border-r-none hidden sm:block sm:border-r-2 border-border-darkNew pr-4">
            {tabs?.map((tab, index) => {
              return (
                <div
                  key={index}
                  className={`${
                    SelectedTab === index
                      ? "bg-background-secondaryOpacity rounded-full text-primary"
                      : "text-white-opacity"
                  } cursor-pointer text-base mb-4 py-2 px-4`}
                  onClick={() => setSelectedTab(index)}
                >
                  {tab.title}
                </div>
              );
            })}
          </div>

          <div className="pb-5 w-full ">{tabs[SelectedTab].component}</div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
